// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminContactRole } from './admin-contact-role';
import { Contact } from './contact';
import { Counterparty } from './counterparty';
import { CounterpartyType } from './counterparty-type';
import { Lookup } from './lookup';
import { MergeTemplateCategory } from './merge-template-category';
import { MergeTemplateGroup } from './merge-template-group';
import { MergeTemplateReplaceField } from './merge-template-replace-field';
import { Report } from './report';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MergeTemplate extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  mergeTemplateId!: number;
  adminContactRoleId?: number;
  baseMergeTemplateId?: number;
  contactId?: number;
  counterpartyId?: number;
  counterpartyTypeId?: number;
  createdBy!: string;
  createdDate!: Date;
  datasource?: string;
  datasourceLookupId?: number;
  description!: string;
  extension?: string;
  flags?: number;
  isCore!: boolean;
  isDefaultForCategory!: boolean;
  isMerge?: boolean;
  isParent?: boolean;
  locationId!: number;
  mergeOption?: number;
  mergeSubOption?: number;
  mergeSubSubOption?: number;
  mergeTemplateCategoryId!: number;
  precedentActionDescription?: string;
  precedentActionId?: number;
  savePath?: string;
  styleTemplatePath?: string;
  systemFlags?: number;
  tag?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  adminContactRole!: AdminContactRole;
  contact!: Contact;
  counterparty!: Counterparty;
  counterpartyType!: CounterpartyType;
  datasourceLookup!: Lookup;
  mergeTemplateCategory!: MergeTemplateCategory;
  mergeTemplateGroupMergeTemplates!: MergeTemplateGroup[];
  mergeTemplateGroupParentMergeTemplates!: MergeTemplateGroup[];
  mergeTemplateReplaceFields!: MergeTemplateReplaceField[];
  reports!: Report[];
}

